(() => {
  const script=document.currentScript;
  const productId=script?.dataset.genkiDemandProduct;
  const endpoint=script?.dataset.genkiDemandEndpoint;
  if(!/^[1-9]\d*$/.test(productId||'')||!endpoint||window.Shopify?.designMode)return;
  const provider=script.dataset.genkiDemandProvider||'amiami';
  if(!['amiami','ninnin'].includes(provider))return;
  const key=`genki-demand-${provider}-${productId}`;
  if(window[key])return;window[key]=true;
  let pollCount=0,stopped=false,generation=0,customerMode=null;
  let notice;
  let eligible=new Set(),displayState='loading',displayChecked=0,confirmedAvailable=null;
  const variants=JSON.parse(script.dataset.genkiDemandVariants||'[]');
  const shared=window.__genkiDemandLocks||(window.__genkiDemandLocks={entries:new Map(),locks:new Map(),badges:new Map()});
  const own={eligible:new Set(),state:'loading',available:null,variant:null};
  shared.entries.set(provider,own);
  const {locks,badges}=shared;
  const motionStyle=document.createElement('style');
  motionStyle.textContent=`
    .genki-stock-check{position:relative;overflow:hidden;padding:18px 18px 22px 62px!important;min-height:78px}
    .genki-stock-check[hidden]{display:none!important}
    .genki-stock-check::before{content:'✓';position:absolute;left:18px;top:20px;font-size:24px;color:#71e5ad}
    .genki-stock-check[aria-busy="true"]::before{content:'';width:26px;height:26px;border:3px solid #ffffff30;border-top-color:#ff963b;border-right-color:#fff;border-radius:50%;animation:genkiCheckSpin 1s linear infinite}
    .genki-stock-check[aria-busy="true"]::after{content:'';position:absolute;bottom:0;left:0;width:35%;height:4px;background:linear-gradient(90deg,transparent,#ff963b,#ffcf8a);animation:genkiCheckSweep 1.8s ease-in-out infinite}
    .genki-stock-check strong{display:block;color:#fff;font-size:17px;line-height:1.35}
    .genki-stock-check .genki-check-detail{display:block;margin-top:5px;color:#dbe3e7;font-size:13px;line-height:1.45}
    .genki-stock-check[data-state="unavailable"]::before{content:'!';color:#ffcf8a}
    @keyframes genkiCheckSpin{to{transform:rotate(360deg)}}
    @keyframes genkiCheckSweep{from{transform:translateX(-100%)}to{transform:translateX(390%)}}
    @media(prefers-reduced-motion:reduce){.genki-stock-check::before,.genki-stock-check::after{animation:none!important}}
  `;
  document.head.append(motionStyle);
  function selectedId(info){return info.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;}
  function acceptScope(result){
    eligible=new Set(Array.isArray(result[provider+'_variants'])?result[provider+'_variants']:[]);
    own.eligible=eligible;
  }
  function enforceLocks(info){
    const pending=[...shared.entries.values()].filter(e=>e.state!=='confirmed');
    const checking=pending.some(e=>e.eligible.has(selectedId(info)));
    const pendingIds=new Set(pending.flatMap(e=>[...e.eligible]));
    const currentIsAA=eligible.has(selectedId(info));
    const wanted=new Set();
    if(pendingIds.size){
      const picker=info.querySelector('variant-selects');
      const groups=picker?[...picker.querySelectorAll('fieldset,select')]:[];
      groups.forEach((group,index)=>{
        group.querySelectorAll('input[type="radio"],option').forEach(control=>{
          const matches=variants.filter(v=>v.options[index]===control.value);
          if(matches.length&&matches.every(v=>pendingIds.has(v.id)))wanted.add(control);
        });
      });
      if(checking)info.querySelectorAll('button[name="add"],button[id^="ProductSubmitButton-"]').forEach(x=>wanted.add(x));
    }
    for(const [control,wasDisabled] of locks){
      if(!wanted.has(control)||!control.isConnected){
        control.disabled=wasDisabled;
        const confirmed=[...shared.entries.values()].find(e=>e.state==='confirmed'&&e.variant===selectedId(info)&&e.available!==null);
        if(confirmed&&control.matches('button[name="add"],button[id^="ProductSubmitButton-"]'))control.disabled=!confirmed.available;
        locks.delete(control);
        badges.get(control)?.remove();badges.delete(control);
      }
    }
    for(const control of wanted){
      if(!locks.has(control))locks.set(control,control.disabled);
      if(!control.disabled)control.disabled=true;
      if(control.type==='radio'&&!badges.has(control)){
        const label=info.querySelector(`label[for="${CSS.escape(control.id)}"]`);
        if(label){const badge=document.createElement('small');badge.style.cssText='display:block;grid-column:1 / -1;flex-basis:100%;white-space:nowrap;color:inherit;font-weight:700';label.append(badge);badges.set(control,badge);}
      }
      const badge=badges.get(control);
      const badgeText='Wird überprüft …';
      if(badge&&badge.textContent!==badgeText)badge.textContent=badgeText;
    }
    const payment=info.querySelector('.shopify-payment-button');
    if(payment){
      if(checking){if(!payment.hasAttribute('data-genki-was-hidden'))payment.dataset.genkiWasHidden=String(payment.hidden);payment.hidden=true;}
      else if(payment.hasAttribute('data-genki-was-hidden')){payment.hidden=payment.dataset.genkiWasHidden==='true';delete payment.dataset.genkiWasHidden;}
    }
    return currentIsAA;
  }
  let successNoticeSeconds=300;
  function showStatus(state,checked){
    displayState=state;displayChecked=checked;own.state=state;
    const info=document.querySelector('product-info[id^="MainProduct-"]');
    if(!info)return;
    const currentIsAA=enforceLocks(info);
    if(!currentIsAA||state==='ignored'||(state==='confirmed'&&checked&&Date.now()/1000>=checked+successNoticeSeconds)){if(notice)notice.hidden=true;return;}
    if(!notice?.isConnected){
      notice=document.createElement('div');
      notice.className='genki-stock-check';
      notice.setAttribute('role','status');
      notice.setAttribute('aria-live','polite');
      notice.setAttribute('aria-atomic','true');
      notice.innerHTML='<strong></strong><span class="genki-check-detail"></span>';
      notice.style.cssText='box-sizing:border-box;width:100%;margin:12px 0;padding:12px 14px;border:1px solid #ff963b;border-radius:10px;background:#152126;color:#f5f5f5;font:600 14px/1.5 sans-serif;box-shadow:0 0 9px #ff963b26;overflow-wrap:anywhere';
      const target=info.querySelector('variant-selects')||info.querySelector('[id^="Quantity-Form-"]');
      if(target)target.before(notice);else info.prepend(notice);
    }
    notice.hidden=state==='ignored';
    notice.dataset.state=state;
    notice.setAttribute('aria-busy',String(['queued','running','loading','busy','offline','unconfirmed'].includes(state)));
    const stamp=checked?new Date(checked*1000).toLocaleTimeString('de-DE',{hour:'2-digit',minute:'2-digit'}):'';
    const pending=['queued','running','loading','busy','offline','unconfirmed'].includes(state);
    const title=state==='confirmed'?'Preis & Bestand aktualisiert':pending?'Preis & Bestand werden geprüft …':'Prüfung noch nicht bestätigt';
    const detail=state==='confirmed'?(stamp?'Zuletzt geprüft um '+stamp+' Uhr.':'Prüfung abgeschlossen.'):
      ['running','loading'].includes(state)?'Partner wird abgefragt. Bitte einen Moment warten.':
      pending?'Wir fragen Preis und Verfügbarkeit beim Partner ab. Wir bitten um einen Moment Geduld.':
      'Diese Variante bleibt vorübergehend gesperrt. Bitte später erneut versuchen.';
    if(notice.querySelector('strong').textContent!==title)notice.querySelector('strong').textContent=title;
    if(notice.querySelector('.genki-check-detail').textContent!==detail)notice.querySelector('.genki-check-detail').textContent=detail;
  }
  const pause=ms=>new Promise(resolve=>setTimeout(resolve,ms));
  let visitorProof=null,visitorProofAt=0;
  async function customerProof(){
    if(!visitorProof||Date.now()-visitorProofAt>240000){
      visitorProofAt=Date.now();
      visitorProof=fetch('/apps/genkidama/amiami-visitor?product_id='+encodeURIComponent(productId)+'&provider='+provider,{
        credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(3000)
      }).then(r=>r.ok?r.json():{}).then(r=>r.visitor_token||'').catch(()=>'');
    }
    return visitorProof;
  }
  async function api(path,body){
    if(path==='/request'&&body)body={...body,visitor_token:await customerProof()};
    const response=await fetch(endpoint+path,{method:body?'POST':'GET',
      ...(body?{headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}:{}),
      credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(10000)});
    if(!response.ok&&response.status!==429)throw new Error('availability unavailable');
    return response.json();
  }
  async function refreshProduct(checked){
    const info=document.querySelector('product-info[id^="MainProduct-"]');
    if(!info||typeof info.handleUpdateProductInfo!=='function')return;
    const selected=()=>info.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    const variant=selected();if(!variant)return;
    const productUrl=new URL(info.dataset.url||location.pathname,location.origin);
    if(productUrl.origin!==location.origin)return;
    productUrl.searchParams.set('variant',variant);
    productUrl.searchParams.set('section_id',info.dataset.section);
    productUrl.searchParams.set('_availability',Date.now());
    const response=await fetch(productUrl,{cache:'no-store',signal:AbortSignal.timeout(15000)});
    if(!response.ok)return;
    const html=new DOMParser().parseFromString(await response.text(),'text/html');
    if(!info.isConnected||selected()!==variant||!html.querySelector('product-info'))return;
    const fresh=info.getSelectedVariant(html);
    if(String(fresh?.id)!==variant)return;
    const quantity=info.querySelector('input[name="quantity"]');
    const count=quantity?.value;
    info.handleUpdateProductInfo(info.dataset.url)(html);
    const after=info.querySelector('input[name="quantity"]');
    if(after&&count){
      const current=after.value;after.value=count;
      if(!after.checkValidity())after.value=current;
    }
    info.dataset.genkiAvailabilityChecked=String(checked);
    confirmedAvailable=Boolean(fresh.available);own.available=confirmedAvailable;own.variant=variant;
    return true;
  }
  const lockTimer=setInterval(()=>{if(!stopped)showStatus(displayState,displayChecked);},1000);
  document.addEventListener('submit',event=>{
    const info=event.target.closest('product-info');
    if(info&&eligible.has(selectedId(info))&&displayState!=='confirmed'&&event.target.matches('form[action*="/cart/add"]')){
      event.preventDefault();event.stopImmediatePropagation();showStatus(displayState,displayChecked);
    }
  },true);
  window.addEventListener('pagehide',()=>{stopped=true;clearInterval(lockTimer);},{once:true});
  async function start(){
    const run=++generation;pollCount=0;
    showStatus('loading');
    try{
      let result=await api('/request',{product_id:productId});
      if(run!==generation)return;
      acceptScope(result);
      script.dataset.state=result.state;
      if(result.state!=='confirmed')showStatus(result.state);
      while(!stopped&&['queued','running','busy','offline','unconfirmed'].includes(result.state)&&pollCount++<180){
        const retry=['busy','offline','unconfirmed'].includes(result.state);
        await pause(retry?15000:5000);if(stopped||run!==generation)return;
        if(document.hidden)continue;
        result=retry?await api('/request',{product_id:productId}):await api('/status?product_id='+encodeURIComponent(productId));
        if(run!==generation)return;
      acceptScope(result);
        script.dataset.state=result.state;
        if(result.state!=='confirmed')showStatus(result.state);
      }
      if(stopped||run!==generation)return;
      if(result.state==='confirmed'&&result.checked&&eligible.size){
        const updated=await refreshProduct(result.checked);
        if(run!==generation)return;
        showStatus(updated?'confirmed':'unavailable',result.checked);
      }else if(result.state!=='ignored')showStatus('unavailable');
    }catch{if(!stopped&&run===generation)showStatus('unavailable');}
  }
  async function refreshPolicy(){
    if(stopped||document.hidden)return;
    try{
      const result=await api('/policy');
      if(stopped)return;
      if(Number.isFinite(result.success_notice_seconds))successNoticeSeconds=result.success_notice_seconds;
      const enabled=result.customer_check===true;
      if(enabled===customerMode)return;
      customerMode=enabled;
      if(enabled){start();}
      else{
        generation++;eligible=new Set();own.eligible=eligible;own.state='ignored';
        showStatus('ignored');if(notice)notice.hidden=true;
      }
    }catch{/* Keep the last known policy; never create a check from a failed policy read. */}
  }
  const policyTimer=setInterval(refreshPolicy,30000);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refreshPolicy();});
  window.addEventListener('pagehide',()=>clearInterval(policyTimer),{once:true});
  refreshPolicy();
})();
